import { Injectable, Inject } from '@angular/core';

@Injectable()
export class ConfigService {

  _apiURI: string;

  constructor(@Inject('BASE_URL') baseUrl: string) {
    this.setBaseUrl(baseUrl);
  }

  getApiURI() {
    return this._apiURI;
  }

  setBaseUrl(baseUrl: string) {
    if (!baseUrl.toLowerCase().trim().endsWith('api')) {
      this._apiURI = baseUrl + 'api';
    } else {
      this._apiURI = baseUrl;
    }
  }
}
